import { createContext } from 'react';

const ModelContext = createContext();

export default ModelContext;
